<template>
  <div class="section-main__warp record">
    <ioc-table
      :data="tableData"
      :option="option"
      :page="page"
      ref="crud"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <!-- 顶部按钮 自定义 -->
      <template #menuLeft>
        <div class="tabBar">
          <div
            v-for="(item, index) in tabBar"
            :key="index"
            :class="['barItem', activeIndex === index ? 'active' : '']"
            @click="handleChooseItem(index)"
          >
            {{ item }}
          </div>
        </div>
      </template>
      <template #menuRight>
        <el-button
          type="primary"
          size="small"
          v-auth="'/assetsManage/record:export'"
          class="iss-operation-button"
          icon="el-icon-download"
          @click="exportDocument"
        >
          导出
        </el-button>
      </template>
      <template slot="search_buildingName" slot-scope="scope">
        <el-select v-model="scope.row.buildingCode" clearable placeholder="请选择">
          <el-option
            v-for="item in buildingList"
            :key="item.buildingCode"
            :label="item.buildingName"
            :value="item.buildingCode"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="search_inspectorTime" slot-scope="scope">
        <el-date-picker
          v-model="scope.row.inspectorTime"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择月"
        >
        </el-date-picker>
      </template>
      <template slot="status" slot-scope="scope">
        {{ hasStatusLabel(scope.row.status) }}
      </template>
      <template slot="statusView" slot-scope="scope">
        {{ hasStatusLabel(scope.row.status) }}
      </template>
      <template #viewFormSet="{ row }">
        <div class="flex-row" style="margin-bottom: 20px">
          <label style="width: 100px; padding-right: 12px">巡检项目</label>
          <div class="recordForm">
            <div
              class="patrolItemList"
              v-for="(item, index) in row.patrolItemRecordInfoList"
              :key="index"
            >
              <label>{{ item.patrolItemName }}</label>
              <span :style="{ color: hasPatrolItemColor(item.patrolitemStatus) }">{{
                hasPatrolItemStatus(item.patrolitemStatus)
              }}</span>
            </div>
            <div class="patrolItemList">
              <label>图片</label>
              <div class="record-pic">
                <el-image
                  :src="getImgPath(item)"
                  z-index="3000"
                  v-for="(item, index) in picFileCode"
                  :key="index"
                  style="height: 150px; width: 150px; margin-right: 10px"
                  :preview-src-list="[getImgPath(item)]"
                ></el-image>
              </div>
            </div>
            <div class="patrolItemList">
              <label>视频</label>
              <div class="record-video">
                <video
                  v-for="(item, index) in videoFileCode"
                  :key="index"
                  :src="getImgPath(item)"
                  width="300"
                  height="150"
                  controls="controls"
                >
                  您的浏览器不支持 video 标签。
                </video>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-if="scope.row.status !== '1'"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
      <!--表格自定义-->
      <template slot="inspectionResult" slot-scope="scope">
        <span
          v-if="scope.row.inspectionResult === '1'"
          style="cursor: pointer"
          @click="handleView(scope.row, scope.index)"
          >正常</span
        >
        <span
          v-if="scope.row.inspectionResult === '2'"
          style="color: #ff4547; cursor: pointer"
          @click="handleView(scope.row, scope.index)"
          >异常</span
        >
      </template>

      <template slot="patrolItemNames" slot-scope="scope">
        <span v-if="scope.row.inspectionResult === '2'" style="color: #ff4547">{{
          scope.row.patrolItemNames
        }}</span>
      </template>
      <!-- 查看详情表单 自定义 -->

      <template slot="fireassetDetailView" slot-scope="scope">
        <div
          class="slot-form"
          v-if="scope.row.fireassetType == 1 || scope.row.fireassetType == 2"
        >
          <label class="item-label">灭火器：</label>
          <table class="info-table">
            <tr>
              <th class="table-index">序号</th>
              <th style="width: 230px">型号</th>
              <th style="width: 100px">数量</th>
              <th style="width: 150px">生产日期</th>
              <th style="width: 150px">检修日期</th>
            </tr>
            <tr v-for="(item, index) in scope.row.annihilatorList" :key="index">
              <td class="table-index" v-if="scope.row.annihilatorList">
                {{ index + 1 }}
              </td>
              <td>
                {{ returnAnnihilator(scope.row.annihilatorList[index].fireassetVersion) }}
              </td>
              <td>
                {{ scope.row.annihilatorList[index].number }}
              </td>
              <td>
                {{ scope.row.annihilatorList[index].produceTime }}
              </td>
              <td>
                {{ scope.row.annihilatorList[index].fixTime }}
              </td>
            </tr>
          </table>
        </div>
        <div class="slot-form" v-if="scope.row.fireassetType == 2">
          <label class="item-label">消火栓：</label>
          <table class="info-table">
            <tr>
              <th class="table-index">序号</th>
              <th style="width: 400px">名称</th>
              <th style="width: 200px">数量</th>
            </tr>
            <tr v-for="(item, index) in scope.row.hydrantList" :key="index">
              <td class="table-index" v-if="scope.row.hydrantList">
                {{ index + 1 }}
              </td>
              <td>
                {{ scope.row.hydrantList[index].name }}
              </td>
              <td>
                {{ scope.row.hydrantList[index].number }}
              </td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="personnelPartView" slot-scope="scope">
        {{ returnDepartNames(scope.row) }}
      </template>
      <template slot="patrolItemNamesView" slot-scope="scope">
        <span v-if="scope.row.inspectionResult === '2'" style="color: #ff4547">
          {{ scope.row.patrolItemNames }}</span
        >
        <span v-else> 无</span>
      </template>
      <template slot="inspectionResultView" slot-scope="scope">
        <span v-if="scope.row.inspectionResult === '2'" style="color: #ff4547">异常</span>
      </template>
      <template slot="planCodeView" slot-scope="scope">
        {{ hasReturnLabel(scope.row.planCode, planList, "planCode", "planName") }}
      </template>
      <template slot="patrolItemGroupCodeView" slot-scope="scope">
        {{
          hasReturnLabel(
            scope.row.patrolItemGroupCode,
            groupList,
            "patrolItemGroupCode",
            "patrolItemGroupName"
          )
        }}
      </template>
      <template slot="viewFormSet" slot-scope="scope">
        <div class="qrCode" style="display: flex; margin-left: 56px">
          <label style="width: 80px">设备二维码</label>
          <div class="code-content">
            <span style="margin-left: 4px; width: 100%">{{
              scope.row.fireassetName
            }}</span>
            <vue-qr
              :text="
                h5Url +
                '/#/pages/fire-equipment/information?fireassetCode=' +
                scope.row.fireassetCode
              "
              :logoSrc="downloadData.icon"
              :size="60"
              :margin="5"
            ></vue-qr>
          </div>
        </div>
        <div
          class="qrCode"
          style="display: flex; margin-left: 70px"
          v-if="scope.row.picFileCode"
        >
          <label style="width: 70px">问题图片</label>
          <div class="img-content">
            <div
              v-for="(item, index) in scope.row.picFileCode.split(',').map((el) => {
                return el;
              })"
              :key="index"
            >
              <img
                :src="getImgPath(item)"
                @click="showViewer(getImgPath(item), $event)"
                onerror="this.src='/images/theme/newDark/default.png'"
              />
            </div>
          </div>
        </div>
        <div
          class="qrCode"
          style="display: flex; margin-left: 70px"
          v-if="scope.row.videoFileCode"
        >
          <label style="width: 70px">问题视频</label>
          <div class="img-content">
            <div
              v-for="(item, index) in scope.row.videoFileCode.split(',').map((el) => {
                return el;
              })"
              :key="index"
            >
              <video
                :src="getImgPath(item)"
                preload="none"
                controls="controls"
                width="300"
                height="150"
              >
                您的浏览器不支持 video 标签。
              </video>
            </div>
          </div>
        </div>
      </template>
      <!-- <template slot="viewFormSet"
                slot-scope="scope">
        
      </template> -->
      <!-- 视频 -->
      <!-- <template slot="picFileCodeView"
                slot-scope="scope">
      <video v-if="scope.inspectionResult === 2"
             :src="Bus.imgPath(item.fileCode)"
             controls="controls"></video>
      </template> -->
    </ioc-table>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>

<script>
import option from "../const/record";
import utils from "@src/common/utils";
import { Bus, Dates } from "$utils";
import { api } from "../api";
import vueQr from "vue-qr";

export default {
  components: {
    vueQr,
  },
  name: "record",
  data() {
    return {
      viewerInstance: null,
      viewerPhotos: [],
      h5Url: utils.Cache.get("SYS_H5"),
      downloadData: {
        // url: "http://10.40.146.150:8081/#/pages/workorder/handle-add?templateCode=20210617000495"//需要转化成二维码的网址
        url: "", //需要转化成二维码的网址
        icon: require("../../../../src/common/assets/images/logo.png"), //二维码中间的图片,可以不设置
      },
      picFileCode: [],
      videoFileCode: [],
      buildingList: [],
      activeIndex: 0,
      tabBar: ["资产维度", "楼栋维度"],
      tableData: [],
      searchParams: {
        buildingCode: "",
        fireassetName: "",
        inspectionResult: "",
        inspectorTime: "",
        planCycle: "",
      },
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      option: option,
    };
  },
  created() {
    this.getBuildingList();
  },
  mounted() {
    const params = this.$route.params;
    if (JSON.stringify(params) !== "{}") {
      this.searchParams.buildingCode = params.buildingCode;
      this.searchParams.inspectorTime = params.analysisTime;
      this.searchParams.planCycle = params.planCycle;
      this.$refs.crud.searchForm = JSON.parse(JSON.stringify(this.searchParams));
    }
    this.getList();
  },
  methods: {
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(src, e) {
      // this.viewerPhotos = [e.target.src];
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    //灭火器型号
    returnAnnihilator(value) {
      if (value) {
        return value == 1 ? "MFZ/ABC6" : "FZX-ACT8/1.2-JXJA";
      }
    },
    //导出
    exportDocument() {
      const params = {
        buildingCode: this.searchParams.buildingCode,
        fireassetName: this.searchParams.fireassetName,
        inspectionResult: this.searchParams.inspectionResult, //  巡检结果：1：正常 2:异常
        inspectorTime: this.searchParams.inspectorTime,
        planCycle: this.searchParams.planCycle,
      };
      // 兼容IE
      this.$fetchDownLoad(api.assetsManage.exportFireAssetDeviceRecord, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          const fileName =
            "巡检记录信息" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
      });
    },
    getBuildingList() {
      const param = {
        pageFlag: false,
        buildingType: 1, //1楼栋2楼层
      };
      this.$fetch(api.assetsManage.queryBuildingList, param).then((res) => {
        if (res.success) {
          this.buildingList = res.returnObj;
        }
      });
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    hasPatrolItemColor(val) {
      switch (val) {
        case "1":
          return "#26BF7D";
        case "2":
          return "#E94E4E";
        default:
          return "#26BF7D";
      }
    },
    hasPatrolItemStatus(val) {
      switch (val) {
        case "1":
          return "正常";
        case "2":
          return "异常";
        default:
          return "";
      }
    },
    hasStatusLabel(val) {
      switch (val) {
        case "1":
          return "待巡检";
        case "2":
          return "已巡检(待审核)";
        case "3":
          return "已审核";
        default:
          return "";
      }
    },
    handleView(row, index) {
      this.picFileCode = [];
      this.videoFileCode = [];
      if (row.picFileCode && row.picFileCode !== "") {
        this.picFileCode = row.picFileCode.split(",");
      }
      if (row.videoFileCode && row.videoFileCode !== "") {
        this.videoFileCode = row.videoFileCode.split(",");
      }
      this.$refs.crud.rowView(row, index);
    },
    handleSearchReset() {
      this.searchParams.buildingName = "";
      this.searchParams.buildingCode = "";
      this.searchParams.fireassetName = "";
      this.searchParams.inspectionResult = "";
      this.searchParams.inspectorTime = "";
      this.searchParams.planCycle = "";
      this.page = {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      };
      this.getList();
    },
    getList() {
      const params = {
        buildingName: this.searchParams.buildingName,
        buildingCode: this.searchParams.buildingCode,
        fireassetName: this.searchParams.fireassetName,
        inspectionResult: this.searchParams.inspectionResult, //  巡检结果：1：正常 2:异常
        inspectorTime: this.searchParams.inspectorTime,
        planCycle: this.searchParams.planCycle,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$fetch(api.assetsManage.queryFireAssetDeviceRecordByPage, params).then(
        (response) => {
          setTimeout(() => {
            loading.close();
          }, 500);

          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.tableData = response.returnObj
            ? Object.freeze([...response.returnObj.list])
            : [];
          this.page.total = response.returnObj ? response.returnObj.total : 0;
          this.$refs.crud.selectClear();
        }
      );
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleSearchChange(param) {
      this.searchParams = param;
      this.page.currentPage = 1;
      this.getList();
    },
    handleChooseItem(index) {
      this.activeIndex = index;
      if (index === 1) {
        this.$router.push({
          name: "assetsBuilding",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.el-scrollbar {
  padding-bottom: 30px;
}

.code-content {
  display: flex;
  width: 100px;
  padding-bottom: 5px;
  flex-direction: column;
}

.img-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  img {
    margin-right: 5px;
    width: 100px;
    height: 100px;
  }
}

.slot-form {
  table {
    border-collapse: collapse;
  }

  .info-table td,
  th {
    border: 1px solid;
    text-align: center;
    @include set_theme_color(border-color, top-menu-border-color);
  }

  th,
  td > el-input {
    font: 8px;
    text-align: center;
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .table-index {
    width: 40px;
  }
}

.el-input__inner {
  height: 32px;
  text-align: center;
  line-height: 32px;
}

// .info-table td,
// th {
//   border: 1px solid;
//   text-align: center;
//   @include set_theme_color(border-color, top-menu-border-color);
// }
.record {
  .add-row {
    .el-scrollbar {
      padding-bottom: 30px;
    }
  }

  .table-type {
    width: 240px;
  }

  .tabBar {
    display: flex;

    .barItem {
      // color: white;
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      margin: 9px 27px;

      &.active {
        color: #409eff;
      }
    }
  }
}

.recordForm {
  display: flex;
  flex-direction: column;
  flex: 1;

  .patrolItemList {
    display: flex;
    margin-bottom: 18px;

    label {
      margin-right: 24px;
    }

    .record-pic {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
    }

    .record-video {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-bottom: 16px;
    }
  }
}
</style>
